var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useHttp } from '../../hooks/useHttp';
import { AVN } from '../../img';
const Navbar = ({ name, surname, auth, setUser, setAuth }) => {
    const { request } = useHttp();
    const { t, i18n } = useTranslation();
    const lang = localStorage.getItem('lang');
    const changeLang = (lng) => {
        i18n.changeLanguage(lng);
    };
    const logout = () => __awaiter(void 0, void 0, void 0, function* () {
        const { data, logout, type, message } = yield request('/auth/logout');
        toast[type](message);
        if (logout) {
            setUser({
                access: false,
                name: null,
                AVN_login: null,
                surname: null,
                patronymic: null,
                visible: false,
                id_AVN_user: null,
            });
            setAuth({ id_avn_user: null, isAuth: false, id_user: null, id_role: null });
        }
    });
    return (_jsxs("header", Object.assign({ className: "d-flex justify-content-between align-items-center bg-primary text-light position-fixed w-100 top-0", style: { padding: '0 20px', minHeight: '60px', zIndex: '3' } }, { children: [_jsxs("div", Object.assign({ className: "d-flex justify-content-start gap-5 align-items-center w-100" }, { children: [_jsx("img", { src: AVN, alt: "avn", style: { width: '90px' } }), _jsxs("div", Object.assign({ className: "d-flex justify-content-between gap-2 align-items-center" }, { children: [_jsx("div", Object.assign({ style: lang == 'kg' ? { fontWeight: 'bold', cursor: 'pointer' } : { cursor: 'pointer' }, onClick: changeLang.bind(null, 'kg') }, { children: "\u041A\u044B\u0440" })), _jsx("div", Object.assign({ style: lang == 'ru' ? { fontWeight: 'bold', cursor: 'pointer' } : { cursor: 'pointer' }, onClick: changeLang.bind(null, 'ru') }, { children: "\u0420\u0443\u0441" }))] }))] })), _jsx("h4", Object.assign({ className: "w-100 text-center", style: { fontWeight: 'bold' } }, { children: t('header') })), _jsx("div", Object.assign({ className: "w-100", style: { textAlign: 'right' } }, { children: auth && (_jsxs(_Fragment, { children: [name, " ", surname, _jsx("br", {}), _jsx("i", { onClick: logout, style: { cursor: 'pointer' }, title: t('logout'), className: "fa-solid fa-arrow-right-from-bracket" })] })) }))] })));
};
export default Navbar;
